import { Router } from '@remix-run/router';
import { createStore } from 'zustand-x';
import { Config } from '@core/types';

export const configStore = createStore('config')<Config>({
  apiUrl: '',
  wsUrl: '',
  environment: '',
  storageKeyPrefix: '',
  projectName: '',
  defaultRoute: '',
  router: {} as Router,
}).extendActions((set) => ({
  initialize: (config: Config) => {
    set.state(() => config);
  },
}));
